// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { hoursToMilliseconds as fn } from "../hoursToMilliseconds.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const hoursToMilliseconds = convertToFP(fn, 1);

// Fallback for modularized imports:
export default hoursToMilliseconds;
